/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum DateSpecificityType {
  TimeDayMonthYear = 'TimeDayMonthYear',
  DayMonthYear = 'DayMonthYear',
  MonthYear = 'MonthYear',
  Year = 'Year'
}
